import { UserActionType } from './types';

export const fetchMeSuccess = user => ({
  type: UserActionType.FETCH_ME_SUCCESS,
  data: user
});

export const saveSettingsSuccess = ({ settings }) => ({
  type: UserActionType.SAVE_SETTINGS_SUCCESS,
  data: settings
});

export const userLoginStarted = () => ({
  type: UserActionType.USER_LOGIN_STARTED
});

export const logoutUser = () => ({
  type: UserActionType.LOGOUT_USER
});

export const userActionError = ({ err, isForbidden }) => ({
  type: UserActionType.USER_ACTION_ERROR,
  data: { err, isForbidden }
});
export const userResetError = () => ({
  type: UserActionType.RESET_STATE
});

export const removeOneTourStepByTourName = ({ tourName, stepName }) => ({
  type: UserActionType.REMOVE_TOUR_STEP,
  data: { tourName, stepName }
});

export const removeMultipleTourStepByTourName = ({ tourName, stepNames }) => ({
  type: UserActionType.REMOVE_MULTIPLE_TOUR_STEPS,
  data: { tourName, stepNames }
});

export const removeAllTourStepsByTourName = ({ tourName }) => ({
  type: UserActionType.REMOVE_ALL_TOUR_STEPS,
  data: { tourName }
});

export const updateSetting = ({ name, value }) => ({
  type: UserActionType.UPDATE_SETTING,
  data: { name, value }
});
